import React, { useContext } from "react";

import { css } from "@emotion/react";

import { DiscountProgressBarContext } from "../../context";

export const LockedBreakpoint3 = () => {
  const { theme } = useContext(DiscountProgressBarContext);
  const circleClass = css`
    fill: ${theme.breakpoint.inactiveColor};
    stroke: ${theme.container.backgroundColor};
    stroke-width: 2;
  `;

  return (
    <span
      className={"ig-dp-locked-breakpoint"}
      css={css`
        display: flex;
        height: 16px;
      `}
    >
      <svg width="16px" height="16px">
        <circle cx="8" cy="8" r="7" css={circleClass} />
      </svg>
    </span>
  );
};
